import { useTranslation } from 'react-i18next';
import './Banner.scss';
import {ReactComponent as WarningIcon} from '../../assets/icons/reports/warning.svg';
import { SystemStore } from '../../store/System';
import { format } from 'date-fns';
import { getTimeFormatDate } from '../../utils/functions';
import { observer } from 'mobx-react';

type BannerT = {
  clearStateBanner: ()=> void;
}

const Banner = (props: BannerT) => {
  const { startDateTime, endDateTime } = SystemStore.systemState;

  const { clearStateBanner } = props;
  const { t } = useTranslation();
  
  return (
    <div className='banner-block'>
      <div className='banner-block_info'>
        <div className='banner-block_icon'>
          <WarningIcon/>
        </div>
        <div>
          <>
            {t('messagesForBanners.mainMsgBanner',
              {
                date: format(new Date(startDateTime) || new Date(),'dd.MM.yyyy') || '',
                timeFrom: getTimeFormatDate(new Date(startDateTime) || new Date()) || '',
                timeTo: getTimeFormatDate(new Date(endDateTime) || new Date()) || ''
              })
            }
          </>
        </div>
      </div>
      <div className='banner-block_button'>
        <button onClick={()=>clearStateBanner()}>{t('close')}</button>
      </div>
    </div>
  );
};

export default observer(Banner);